export const getKeys = Object.keys as <T>(obj: T) => Array<keyof T>;
